<mat-tab-group animationDuration="0ms">
    <mat-tab label="Compras">
        <app-buys></app-buys>
    </mat-tab>
    <mat-tab label="Ventas">
        <app-sales></app-sales>
    </mat-tab>
</mat-tab-group>